import { AccidentsReportsAreaRoutes } from '@backoffice-frontend/common'
import type { AreaNavigationProps } from '@backoffice-frontend/patterns'
import { NavigationItem } from '@backoffice-frontend/patterns'
import { WarningIcon } from '@moia-dev/pace-icons'

export const AccidentsReportsAreaNavigationIcon = WarningIcon

export const AccidentsReportsAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={AccidentsReportsAreaRoutes.route}
      Icon={WarningIcon}
    />
  )
}
